import { Component, HostListener, ChangeDetectorRef, ViewChild, AfterViewInit, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { LlInfoRequestsService } from '../ll-info-requests.service';;
import { LlPermissionsService } from '../ll-permissions.service';

@Component({
  selector: 'll-info-request-spreadsheet-mapping',
  templateUrl: './ll-info-request-spreadsheet-mapping.component.html',
  styleUrls: ['../cssSpreadSheet.css'],
})

export class LlInfoRequestSpreadsheetMappingComponent {

  @ViewChild('mainDiv_ll_info_request_spreadsheet_mapping') mainDiv: ElementRef;
  @ViewChild('scrollBox') scrollBox: ElementRef;
  constructor(
    private cdr: ChangeDetectorRef,
    public LlInfoRequestsService: LlInfoRequestsService,
    private LlPermissionsService: LlPermissionsService,
  ) {
  }

  private draggedCell: any = null;
  private dragFeedbackElement: any = null;

  bundle = {
    showThis: false,
    showDG: false,
    canUpload: false,
    sourceData: [],
    sourceHeaders: [],
    sourceColumnWidths: [],
    targetHeaders: [],
    targetData:[],
    targetRowColors: [],
    targetGridBackgroundColor: '#FFFFFF',
    sourceCellColors: {} as { [row: number]: { [col: number]: string } },
    dropCount:0,
    questions:[],
    documents: [],    
    docDropDown:[],
    docIndex: 0,
    targetValueRowIndx:99999,
    STUDYQUESTIONID: 0,
    QUESTIONRESULT_USER:"",
    LlInfoRequestsService: this.LlInfoRequestsService,
    parentW: 0,
    parentH: 0,
    objW:0,
    objH: 0,
    targetGridWidth: 400,
    targetGridX: 0, 
    gridY: 0,
    gridX: 10,
    gridW: 0,
    gridH: 0,
    spW: 0,
    spH: 60,
    questionNameW: 225,
    targetColumnWidths: [],
    LOANMODELUPLOADMAPID: 0,
    ROWLABEL: '',
    COLUMNLABEL: '',
    acceptedExts:'',
  }

  ngOnInit() { }

  eventSubscription_reflectChange: any;

  ngOnDestroy() {
    this.eventSubscription_reflectChange.unsubscribe();
  }

  ngAfterViewInit() {

    this.eventSubscription_reflectChange = this.LlInfoRequestsService.viewSpreadSheetMapping.subscribe(ARR => {
      this.setVars();
    });

  }

  setVars() {

    if (this.LlPermissionsService.check("upload")) {
      ///this.bundle.canUpload = true;  ///prefer for user to uplad in form at this time
    }

    this.bundle.docIndex = 0;

    this.bundle.objW = window.innerWidth - 60;
    this.bundle.objH = window.innerHeight - 80;
    this.bundle.gridY = this.bundle.spH + 10;
    this.bundle.gridW = this.bundle.objW - (this.bundle.gridX * 2) - this.bundle.targetGridWidth - 40;
    this.bundle.gridH = this.bundle.objH - this.bundle.gridY - 30;
    this.bundle.spW = this.bundle.gridW - 290

    this.bundle.targetGridX = this.bundle.gridX + this.bundle.gridW;  
    this.bundle.targetColumnWidths = [this.bundle.questionNameW, 90];

    this.bundle.showThis = true;
    this.bundle.showDG = false;

    setTimeout(() => {

      this.getData(this.bundle);
    });
    
  }

  getData(bundle) {

    bundle.LlInfoRequestsService.NG_LL_infoReq_uploads_map_acceptedExtentions_get(done01, bundle);

    function done01(acceptedExts, bundle) {

      bundle.acceptedExts = acceptedExts

      ///console.log(bundle.acceptedExts)

      bundle.LlInfoRequestsService.NG_LL_infoReq_uploads_map_docs_get(done02, bundle);
    }

    function done02(documents, bundle) {

      bundle.documents = documents;

      let activeStudyUploadId = bundle.LlInfoRequestsService.getActiveStudyUploadId();

      //if (activeStudyUploadId == 0 && bundle.documents.length > 0) {
        //activeStudyUploadId = bundle.documents[0].STUDYUPLOADID
      //}

      for (let i = 0; i < bundle.documents.length; i++) {
        bundle.docDropDown[i] = bundle.documents[i].FILENAME;

        if (bundle.documents[i].STUDYUPLOADID == activeStudyUploadId) {
          bundle.docIndex = i;
        }
      }

      bundle.LlInfoRequestsService.NG_LL_infoReq_uploads_map(paintGrid_spreadsheet, bundle);
    }
    function paintGrid_spreadsheet(records, bundle) {

      bundle.sourceData = records;
      bundle.sourceHeaders = records[0].COLUMNALLNAMES.split("|");
      bundle.sourceColumnWidths = records[0].COLUMNWIDTHS.split("|");
      let questions_arr = records[0].TARGETVALUES.split("|");

      bundle.LOANMODELUPLOADMAPID = records[0].LOANMODELUPLOADMAPID 
    
      // Clear color information for First Grid (Source)
      bundle.sourceCellColors = {};
      bundle.dropCount = 0;
      bundle.targetData.splice(0);

      for (let i = 0; i < questions_arr.length; i++) {

        if (questions_arr[i] != "" && questions_arr[i] != null) { 

          let components = questions_arr[i].split("^");

          //console.log(components)

          // Use subsequent color for target cell
          let asignedColor = bundle.LlInfoRequestsService.getColorFromIndex(i % 20); // Cycle through 20 colors
          let color = '#FFFFFF';  ///default to white
          let value = components[3]; 
          let rowNum = Number(components[4]) - 1;
          let colNum = Number(components[5]);

          if (Number.isInteger(rowNum) && Number.isInteger(colNum) && value != '' && value != null && rowNum != 0 && colNum != 0) {

            //rowNum = rowNum - 1;  //middleware array is 1 based so subtract one

            //console.log(i)
            color = asignedColor
            
            //color = bundle.LlInfoRequestsService.getColorFromIndex(bundle.dropCount % 20); // Cycle through 20 colors
            //bundle.dropCount++; // Increment for next drop

            if (!bundle.sourceCellColors[rowNum]) {
              bundle.sourceCellColors[rowNum] = {};
            }

            bundle.sourceCellColors[rowNum][colNum] = color;
          }

          
          

          bundle.targetData.push({
            STUDYQUESTIONID: components[0],
            QUESTIONNAME: components[1],
            NGWIDGET: components[2],
            QUESTIONRESULT_USER: value,
            ROWNUMBER: rowNum,
            COLUMNNUMBER:colNum,
            BACKGROUNDCOLOR: color,
            ASSIGNEDCOLOR: asignedColor,
          });
        }
      }

      //console.log(bundle.targetData);

      bundle.targetHeaders = ['Field', 'Value'];
      bundle.targetRowColors = Array(bundle.targetData.length).fill(null);// Reset drag tracking

      //console.log(records[0].COLUMNWIDTHS)

      bundle.showDG = true;

      for (let i = 0; i < bundle.targetData.length; i++) {

        if (bundle.targetData[i].QUESTIONRESULT_USER != "" && bundle.targetData[i].QUESTIONRESULT_USER != null) { 

          bundle.QUESTIONRESULT_USER = bundle.targetData[i].QUESTIONRESULT_USER;
          bundle.LlInfoRequestsService.setActiveStudyQuestionId(bundle.targetData[i].STUDYQUESTIONID);
          bundle.LlInfoRequestsService.NG_LL_infoReq_subjectQuestions_updateValue("STD", bundle);
          
        }
      }
    } 
  }

  goBack() {
    this.bundle.showThis = false;
  }

  showTooltip_01: boolean = false; // Tracks tooltip visibility
  showTooltip_02: boolean = false; // Tracks tooltip visibility
  showTooltip_03: boolean = false; // Tracks tooltip visibility

  docChange(direction: string) {
    direction = direction.toLowerCase();

    if (direction == "up" && this.bundle.docIndex != 0) {
      this.bundle.docIndex = this.bundle.docIndex - 1;
    } else if (direction == "down" && this.bundle.docIndex != this.bundle.documents.length - 1) {
      this.bundle.docIndex = this.bundle.docIndex + 1;
    }

    //console.log(this.bundle.docIndex)

    this.bundle.LlInfoRequestsService.setActiveStudyUploadId(this.bundle.documents[this.bundle.docIndex].STUDYUPLOADID);
    this.getData(this.bundle);

    // Auto-scroll to the selected row
    setTimeout(() => {
      this.autoscrollToSelecteddocIndex()
      //if (this.scrollBox) {
        //const scrollContainer = this.scrollBox.nativeElement;
        //const selectedRow = scrollContainer.querySelector(`[data-index="${this.bundle.docIndex}"]`);
        //if (selectedRow) {
          //selectedRow.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        //}
      //}
    },0);
  }

  autoscrollToSelecteddocIndex() {
    if (this.scrollBox) {
      const scrollContainer = this.scrollBox.nativeElement;
      const selectedRow = scrollContainer.querySelector(`[data-index="${this.bundle.docIndex}"]`);
      if (selectedRow) {
        selectedRow.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  fileUpload(event) {

    // console.log("fileUpload")

    let fileList: FileList = event.target.files;
    this.LlInfoRequestsService.setActiveQuestionTab(0); //view doc
    this.LlInfoRequestsService.setActiveStudyQuestionId(0);


    if (fileList.length > 0) {

      let reader = new FileReader();
      let file: File = fileList[0];
      let value = ""

      reader.readAsDataURL(file);
      reader.onload = () => {


        value = String(reader.result).split(',')[1]

        this.LlInfoRequestsService.NG_LL_infoReq_uploads_add(this.getData, this.bundle, file, value)
      };
    }
  }

  removeMap(rowIndex: number) {

    if (this.bundle.targetData[rowIndex].QUESTIONRESULT_USER != "") { 
    // Get ROWNUMBER and COLUMNNUMBER from targetData
    const sourceRowIndex = this.bundle.targetData[rowIndex].ROWNUMBER; // Convert to 0-based index
    const sourceColIndex = this.bundle.targetData[rowIndex].COLUMNNUMBER;   // Already 1-based, matches colIndex + 1

    // Ensure sourceCellColors has an entry for this row
    if (!this.bundle.sourceCellColors[sourceRowIndex]) {
      this.bundle.sourceCellColors[sourceRowIndex] = {};
    }

    // Set the corresponding source cell background color to white
    this.bundle.sourceCellColors[sourceRowIndex][sourceColIndex] = '#FFFFFF';

    // Change bundle.targetData values
    this.bundle.targetData[rowIndex].BACKGROUNDCOLOR = '#FFFFFF';
    this.bundle.targetData[rowIndex].QUESTIONRESULT_USER = '';
    this.bundle.targetData[rowIndex].ROWNUMBER = 0;
    this.bundle.targetData[rowIndex].COLUMNNUMBER = 0;

    // Log the action (optional)
   // console.log(`Removed mapping at index: ${rowIndex}, Source cell at ROWNUMBER: ${sourceRowIndex + 1}, COLUMNNUMBER: ${sourceColIndex} set to white`);

      this.bundle.QUESTIONRESULT_USER = "";

      this.LlInfoRequestsService.setActiveStudyQuestionId(this.bundle.targetData[rowIndex].STUDYQUESTIONID);            
      this.LlInfoRequestsService.NG_LL_infoReq_uploads_map_valueLocation_remove(done01, this.bundle)     

      function done01(bundle) {
        bundle.LlInfoRequestsService.NG_LL_infoReq_subjectQuestions_updateValue("STD", bundle)
      }


    }
  }

  selectDocument(event: { args: { index: number } }) {
    this.bundle.docIndex = event.args.index; // Update selected index
    this.bundle.LlInfoRequestsService.setActiveStudyUploadId(this.bundle.documents[event.args.index].STUDYUPLOADID);
    this.getData(this.bundle);
  }

  private fixedSecondColumnWidth: number = 200;

  private isResizing = false;
  private startX: number = 0;
  private startWidth: number = 0;
  private columnIndex: number = -1;
  private gridType: 'source' | 'target' = 'source';
  private draggedValue: string = '';
  private draggedRowIndex: number = -1;
  private draggedColIndex: number = -1;
  private highlightedRowIndex: number | null = null;
  private draggedSourceColor: string = '#FFFFFF'; // Store source cell color during drag
  private originalSourceCellColor: string = '#FFFFFF'; // Store original color before hover (Source)
  private originalTargetCellColor: string = '#FFFFFF'; // Store original color before hover (Target)
  ///private bundle.dropCount: number = 0; // Track number of drops for sequential colors

  toggleColor(event: Event) {
    const cell = event.target as HTMLElement;
    cell.classList.toggle('clicked');
  }

  highlightSourceCell(event: Event) {
    const cell = event.target as HTMLElement;
    this.originalSourceCellColor = cell.style.backgroundColor || '#FFFFFF';
    cell.style.backgroundColor = '#E0E0E0'; // Hex: Light gray for hover
  }

  unhighlightSourceCell(event: Event) {
    const cell = event.target as HTMLElement;
    cell.style.backgroundColor = this.originalSourceCellColor;
  }

  highlightCell(event: Event) {
    const cell = event.target as HTMLElement;
    this.originalTargetCellColor = cell.style.backgroundColor || '#FFFFFF';
    cell.style.backgroundColor = '#E0E0E0'; // Hex: Light gray for hover
  }

  unhighlightCell(event: Event) {
    const cell = event.target as HTMLElement;
    cell.style.backgroundColor = this.originalTargetCellColor;
  }

  startResize(event: MouseEvent, index: number, grid: 'source' | 'target', isEdge: boolean) {
    event.preventDefault();
    this.isResizing = true;
    this.startX = event.pageX;
    this.columnIndex = index;
    this.gridType = grid;
    const th = (event.target as HTMLElement).parentElement as HTMLElement;
    this.startWidth = th.offsetWidth;
    document.body.style.cursor = 'col-resize';
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.isResizing) {
      const table = document.getElementById(this.gridType === 'source' ? 'sourceGrid' : 'targetGrid') as HTMLTableElement;
      const th = table.querySelectorAll('th')[this.columnIndex] as HTMLElement;
      let newWidth = this.startWidth + (event.pageX - this.startX);

      if (this.gridType === 'source' && this.columnIndex > 0) {
        newWidth = Math.min(Math.max(50, newWidth), 200);
      } else {
        newWidth = Math.max(50, newWidth);
      }

      const widths = this.gridType === 'source' ? this.bundle.sourceColumnWidths : this.bundle.targetColumnWidths;
      widths[this.columnIndex] = newWidth;
      th.style.width = `${newWidth}px`;

      const rows = table.querySelectorAll('tr');
      rows.forEach((row, rowIndex) => {
        if (rowIndex > 0) {
          const cell = row.children[this.columnIndex] as HTMLElement;
          cell.style.width = `${newWidth}px`;
        }
      });
    }
  }

  @HostListener('document:mouseup')
  onMouseUp(event: MouseEvent) {
    if (this.isResizing) {
      this.isResizing = false;
      document.body.style.cursor = 'default';
    }
  }

  startDrag(event: MouseEvent | DragEvent, value: string, rowIndex: number, colIndex: number) {

    //console.log("startDrag rowIndex:" + rowIndex)

    const cell = event.target as HTMLElement;
    this.draggedSourceColor = cell.style.backgroundColor || this.bundle.sourceCellColors[rowIndex]?.[colIndex + 1] || '#FFFFFF';
    cell.style.backgroundColor = '#D3D3D3'; // Hex: Light gray (temporary drag highlight)
    this.draggedValue = value;
    this.draggedRowIndex = rowIndex;
    this.draggedColIndex = colIndex;

    if (event instanceof DragEvent) {
      event.dataTransfer?.setData('text/plain', value);
      cell.classList.add('dragging');
    }
  }

  highlightTargetRow(event: DragEvent, rowIndex: number) {
    event.preventDefault();
    if (this.highlightedRowIndex !== rowIndex) {
      this.clearHighlightedRow();
      this.highlightedRowIndex = rowIndex;
      const row = (event.target as HTMLElement).closest('tr') as HTMLElement;
      if (row) row.classList.add('drag-over');
    }
  }

  unhighlightTargetRow(event: DragEvent, rowIndex: number) {
    if (this.highlightedRowIndex !== rowIndex) {
      const row = (event.target as HTMLElement).closest('tr') as HTMLElement;
      if (row) row.classList.remove('drag-over');
      this.highlightedRowIndex = null;
    }
  }

  private clearHighlightedRow() {
    if (this.highlightedRowIndex !== null) {
      const table = document.getElementById('targetGrid') as HTMLTableElement;
      const row = table.querySelectorAll('tr')[this.highlightedRowIndex + 1] as HTMLElement;
      if (row) row.classList.remove('drag-over');
      this.highlightedRowIndex = null;
    }
  }

  clearSourceColor(color: string, rowIndex: number, colIndex: number) {
    // Skip if color is white
    if (color.toLowerCase() !== '#ffffff') {
      const sourceTable = document.getElementById('sourceGrid') as HTMLTableElement;
      if (sourceTable) {
        const sourceRows = sourceTable.querySelectorAll('tr');

        // Iterate through rows (skip header row, start at index 1)
        for (let r = 1; r < sourceRows.length; r++) {
          const sourceCells = sourceRows[r].querySelectorAll('td');
          // Start at index 1 to skip ROWNUMBER column
          for (let c = 1; c < sourceCells.length; c++) {
            const cell = sourceCells[c] as HTMLElement;
            const cellColor = getComputedStyle(cell).backgroundColor;

            // Convert computed color (rgb) to hex for comparison
            const hexColor = this.rgbToHex(cellColor);

            // Check if cell matches the color and is not at the specified rowIndex and colIndex
            if (hexColor.toLowerCase() === color.toLowerCase() && !(r - 1 === rowIndex && c === colIndex)) {
              // Update sourceCellColors
              if (!this.bundle.sourceCellColors[r - 1]) {
                this.bundle.sourceCellColors[r - 1] = {};
              }
              this.bundle.sourceCellColors[r - 1][c] = '#FFFFFF';

              // Update DOM directly
              cell.style.backgroundColor = '#FFFFFF';
              console.log(`Set sourceCellColors[${r - 1}][${c}] to #FFFFFF`);
            }
          }
        }
      }

      // Trigger change detection
      this.cdr.detectChanges();
    }
  }

  // Helper function to convert RGB to Hex
  private rgbToHex(rgb: string): string {
    const match = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (!match) return rgb; // Return as-is if not RGB
    const [, r, g, b] = match;
    const toHex = (n: string) => parseInt(n, 10).toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toLowerCase();
  }


  drop(event: DragEvent, rowIndex: number) {
    event.preventDefault();
    this.clearHighlightedRow();

    //console.log("drop rowIndex: " + rowIndex)

    
    const newColor = this.bundle.targetData[rowIndex].ASSIGNEDCOLOR;

    this.clearSourceColor(newColor, this.draggedRowIndex, this.draggedColIndex);

    const table = document.getElementById('targetGrid') as HTMLTableElement;
    const rect = table.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const row = table.querySelectorAll('tr')[rowIndex + 1];
    const targetCell = row?.querySelectorAll('td')[1]; // Second column (QUESTIONRESULT_USER)
    const cellRect = targetCell?.getBoundingClientRect();

    this.bundle.targetData[rowIndex].ROWNUMBER = this.draggedRowIndex;
    this.bundle.targetData[rowIndex].COLUMNNUMBER = this.draggedColIndex;
   
    //console.log("ROWNUMBER: " + this.bundle.targetData[rowIndex].ROWNUMBER)
    //console.log("COLUMNNUMBER: " + this.bundle.targetData[rowIndex].COLUMNNUMBER)

    //console.log("this.draggedRowIndex: " + this.draggedRowIndex)


    if (
      targetCell && cellRect &&
      event.clientX >= cellRect.left &&
      event.clientX <= cellRect.right &&
      event.clientY >= cellRect.top &&
      event.clientY <= cellRect.bottom
    ) {
      this.bundle.targetData[rowIndex].QUESTIONRESULT_USER = this.draggedValue;
      this.bundle.targetRowColors[rowIndex] = this.draggedRowIndex % 20;

      // Use subsequent color for target cell
      //const newColor = this.bundle.LlInfoRequestsService.getColorFromIndex(this.bundle.dropCount % 20); // Cycle through 20 colors
      targetCell.style.backgroundColor = newColor;
      this.bundle.targetData[rowIndex].BACKGROUNDCOLOR = newColor;
      //this.bundle.dropCount++; // Increment for next drop

      targetCell.textContent = this.draggedValue;

      // Set source cell background to the same new color as the target cell
      const sourceTable = document.getElementById('sourceGrid') as HTMLTableElement;

      if (sourceTable) {
        const sourceRows = sourceTable.querySelectorAll('tr');
        if (sourceRows.length > this.draggedRowIndex  ) {
          const sourceRow = sourceRows[this.draggedRowIndex];
          
          const sourceCells = sourceRow.children;
          if (sourceCells.length > this.draggedColIndex) { // Use draggedColIndex directly
            //const sourceCell = sourceCells[this.draggedColIndex] as HTMLElement;
            //sourceCell.style.backgroundColor = newColor;

            if (!this.bundle.sourceCellColors[this.draggedRowIndex]) {
              this.bundle.sourceCellColors[this.draggedRowIndex] = {};
            }
        
            //this.bundle.sourceCellColors[this.draggedRowIndex][this.draggedColIndex] = newColor; // Adjust for ROWNUMBER offset
            this.originalSourceCellColor = newColor

            // Combine all non-numeric values to the left of the dragged cell
            this.bundle.ROWLABEL = '';
            //const rowData = this.bundle.sourceData[this.draggedRowIndex + 1];
            const rowData = this.bundle.sourceData[this.draggedRowIndex + 0];
            ///console.log(rowData)

            const headers = this.bundle.sourceHeaders;

            // Iterate leftward from draggedColIndex - 1 (adjusting for ROWNUMBER)
            for (let i = 0; i <= this.draggedColIndex - 2; i++) {
              const rawValue = rowData[headers[i]];

              if (typeof rawValue === 'string') {

                // Remove dollar signs and commas from rawValue
                const cleanedValue = rawValue.replace(/[\$,]/g, '').trim();

                if (cleanedValue && isNaN(Number(cleanedValue)) && cleanedValue !== '') {

                  if (this.bundle.ROWLABEL == "") {
                    this.bundle.ROWLABEL += rawValue; // Append each non-numeric value in order
                  } else {
                    this.bundle.ROWLABEL = this.bundle.ROWLABEL + "|" + rawValue; // Append each non-numeric value in order

                  }
                }
              }
            }
            // Log or use combined non-numeric values (example: console.log)
            //console.log('Combined non-numeric values to the left:', this.bundle.ROWLABEL);
          }
        }
      }

      ////Find the first non-numeric value above the dragged cell in the same column, ignoring special characters

      this.bundle.COLUMNLABEL = '';
      const columnHeader = this.bundle.sourceHeaders[this.draggedColIndex - 1]; // Adjust for ROWNUMBER
      //let firstNonNumericValueAbove: string | null = null;

      for (let i = this.draggedRowIndex - 1; i >= 0; i--) {
        const rawValue = this.bundle.sourceData[i][columnHeader];
        if (typeof rawValue === 'string') {

          // Remove dollar signs and commas from rawValue
          const cleanedValue = rawValue.replace(/[\$,]/g, '').trim();

          if (cleanedValue && isNaN(Number(cleanedValue)) && cleanedValue !== '') {
            this.bundle.COLUMNLABEL = rawValue; // Return original value with special characters
            break; // Stop at the first non-numeric value
          }
        }
      }
      //console.log('First non-numeric value above (ignoring special chars):', this.bundle.COLUMNLABEL);

    }

    const sourceCells = document.querySelectorAll('#sourceGrid td');
    sourceCells.forEach(cell => cell.classList.remove('dragging'));


    this.bundle.QUESTIONRESULT_USER = this.draggedValue;

    this.LlInfoRequestsService.setActiveStudyQuestionId(this.bundle.targetData[rowIndex].STUDYQUESTIONID)

    if (this.bundle.ROWLABEL != '' && this.bundle.COLUMNLABEL != '') { 
      this.LlInfoRequestsService.NG_LL_infoReq_uploads_map_valueLocation_edit(done01, this.bundle)
    }

    function done01(bundle) { 
      bundle.LlInfoRequestsService.NG_LL_infoReq_subjectQuestions_updateValue("STD", bundle)
    }
  }
};
